import React from 'react';

function AuthBottom({ children }) {
  return (
    <div className="bottom">
      <div className="child child-top-padded">{children}</div>
    </div>
  );
}

export default AuthBottom;



// WEBPACK FOOTER //
// ./src/components/AuthBottom/index.js